function applySplitVariantCard(card) {
  const variantId = card.dataset.variantId;
  const variantImage = card.dataset.variantImage;
  const variantColor = card.dataset.variantColor;

  const img = card.querySelector('img');
  const link = card.querySelector('a[href]');

  if (img && variantImage) {
    img.addEventListener(
      'load',
      function () {
        card.classList.add('split-ready');
      },
      { once: true }
    );
    // Sécurité : si l'image met du temps ou échoue, on révèle quand même après 1.5s
    setTimeout(function () {
      card.classList.add('split-ready');
    }, 1500);

    img.src = variantImage;
    img.srcset = '';
  } else {
    card.classList.add('split-ready');
  }

  if (link && variantId) {
    const url = new URL(link.href, window.location.origin);
    url.searchParams.set('variant', variantId);
    link.href = url.toString();
  }

  if (variantColor) {
    const titleEl = card.querySelector('p[role="heading"]');
    if (titleEl && !titleEl.dataset.colorAppended) {
      titleEl.textContent = titleEl.textContent.trim() + ' - ' + variantColor;
      titleEl.dataset.colorAppended = 'true';
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-split-variant]').forEach(applySplitVariantCard);

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-split-variant]')) {
          applySplitVariantCard(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('[data-split-variant]').forEach(applySplitVariantCard);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});